export default "__VITE_ASSET__BcuEi8xC__"